import { ChildRemoveFactory } from './childRemoveFactory';

import type {
  ChildRemoveEntity,
  ChildRemovePropsPub,
  ChildRemovePropsPvt,
} from './childRemoveEntity';
import type { ChildRemoveIRepository } from './childRemoveIRepository';
import type { EntityDataPubType } from '@/infra/appsync';
import type { ChildRemoveJsonPub, ChildRemoveJsonPvt } from '@/types/domain/childApply/entities/childRemoveEntity';

import { AppsyncRepository } from '@/domain/appsyncRepository';
import {
  EntityName,
} from '@/infra/appsync';

export class ChildRemoveRepository extends AppsyncRepository<
  ChildRemoveEntity,
  ChildRemovePropsPvt,
  ChildRemoveJsonPvt,
  ChildRemovePropsPub,
  ChildRemoveJsonPub
> implements ChildRemoveIRepository {
  private factory = new ChildRemoveFactory();

  protected get entityName(): EntityName {
    const name: EntityName = EntityName.WagakoNurseryChildApplyChildRemoveEntity;
    return name;
  }

  /**
   * DBデータをEntityに変換
   * @param props DBデータ
   * @returns Entity
   */
  protected createFromEntityType = (
    props: EntityDataPubType,
  ) => this.factory.createFromEntityType(props);
}
